import {
  chakra,
  Flex as CkFlex,
  HStack as CkHStack,
  IconButton as CkIconButton,
} from "@chakra-ui/react";

import chakraShouldForwardProp from "utils/chakraShouldForwardProp";

export const NavbarContainer = chakraShouldForwardProp(
  CkFlex,
  ({ borderBottomWidth }) => ({
    py: {
      base: 4,
      md: 8,
    },
    px: {
      base: 4,
      md: 6,
      lg: "100px",
    },
    boxShadow: "background.secondary",
    borderBottomWidth,
    width: "100%"
  })
);

export const HStack = chakra(CkHStack, {
  baseStyle: () => ({
    spacing: 3,
    display: {
      base: "none",
      md: "flex",
    },
  }),
});

export const IconButton = chakra(CkIconButton, {
  baseStyle: () => ({
    display: {
      base: "flex",
      md: "none",
    },
    size: "sm",
    ariaLabel: "Open menu",
    fontSize: "20px",
    variant: "ghost",
  }),
});
